import React from 'react';
import { IconProps } from '../IconProps';
const SvgTrash = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 18 19" fill="none" {...props}>
    <path
      d="M13.474 7.456l-.374 7.105a2 2 0 01-1.997 1.895H6.898a2 2 0 01-1.997-1.895l-.374-7.105M2.75 4.956h12.5M6.75 4.956v-2a1 1 0 011-1h2.5a1 1 0 011 1v2M7.375 8.956l.25 4.5M10.625 8.956l-.25 4.5"
      stroke="#BD0E0E"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgTrash;
